import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

export default function StaffDashboard() {
  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="info"
              icon="assignment"
              title="My Tasks"
              count={14}
              percentage={{
                color: "error",
                amount: "3",
                label: "overdue",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              icon="event"
              title="Upcoming Events"
              count="5"
              percentage={{
                color: "info",
                amount: "2",
                label: "to prepare",
              }}
            />
          </MDBox>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="success"
              icon="check_circle"
              title="Completed"
              count="27"
              percentage={{
                color: "success",
                amount: "+8",
                label: "this month",
              }}
            />
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}
